/**
 * IndexedDB (Dexie.js) pour saisie offline (brief SG-RLT-CDC-MODULES-145
 * §contraintes communes — "OFFLINE Rotations + Carburant").
 *
 * Stratégie : si l'utilisateur saisit hors ligne, on persiste la mutation
 * dans IndexedDB avec syncStatus='pending'. Au retour de connexion (event
 * online), le `useSyncOffline` itère sur les pending et POST sur l'API.
 *
 * Garde en pending si erreur API (avec message) pour retry manuel.
 */
import Dexie, { type Table } from 'dexie';
import type { CreateBonCarburantPayload, CreateVoyagePayload } from '@/api/transport';

export type SyncStatus = 'pending' | 'syncing' | 'synced' | 'error';

export interface PendingVoyage {
  id?:         number;             // auto-increment Dexie
  payload:     CreateVoyagePayload;
  /// Snapshot lisible pour affichage UI sans devoir refetch noms.
  preview: {
    camionCode:  string;
    mineCode:    string;
    chauffeur:   string;
    tonnage:     number;
    dateHeure:   string;
  };
  createdAt:   string;
  syncStatus:  SyncStatus;
  errorMsg?:   string;
  /// Filiale d'émission (pour ne pas mixer entre tenants si l'utilisateur change de compte).
  filialeKey:  string;
}

export interface PendingBonCarburant {
  id?:         number;
  payload:     CreateBonCarburantPayload;
  preview: {
    camionCode:  string;
    mineCode:    string;
    chauffeur:   string;
    qteServie:   number;
    dateHeure:   string;
  };
  createdAt:   string;
  syncStatus:  SyncStatus;
  errorMsg?:   string;
  filialeKey:  string;
}

class OfflineDB extends Dexie {
  voyages!:        Table<PendingVoyage, number>;
  bonsCarburant!:  Table<PendingBonCarburant, number>;

  constructor() {
    super('simgroup-offline');
    this.version(1).stores({
      voyages:        '++id, syncStatus, filialeKey, createdAt',
      bonsCarburant:  '++id, syncStatus, filialeKey, createdAt',
    });
  }
}

export const offlineDB = new OfflineDB();
